(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/components/message-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/components/customer-information/components/message-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const MESSAGE = svs.ticket_partner.physicalTickets.constants.names.MESSAGE;
const _svs$ticket_partner$p = svs.ticket_partner.physicalTickets.constants.FORMS.MESSAGE,
  MESSAGE_LABEL = _svs$ticket_partner$p.MESSAGE_LABEL,
  MESSAGE_MAX = _svs$ticket_partner$p.MESSAGE_MAX,
  MESSAGE_MAX_ERROR = _svs$ticket_partner$p.MESSAGE_MAX_ERROR,
  MESSAGE_ROWS = _svs$ticket_partner$p.MESSAGE_ROWS;
const MessageInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state;
  return React.createElement(TextInput, {
    errorMessageMax: MESSAGE_MAX_ERROR,
    id: MESSAGE,
    isMultiline: true,
    isRequired: false,
    label: MESSAGE_LABEL,
    max: MESSAGE_MAX,
    name: MESSAGE,
    onChange: handleChange,
    rows: MESSAGE_ROWS,
    value: state[MESSAGE]
  });
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.components.MessageInput = MessageInput;

 })(window);